import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { prioritiesAPI } from '../../services/api';

// Асинхронные экшены
export const fetchPriorities = createAsyncThunk(
  'priorities/fetchPriorities',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await prioritiesAPI.getAll(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPriorityById = createAsyncThunk(
  'priorities/fetchPriorityById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await prioritiesAPI.getById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const prioritiesSlice = createSlice({
  name: 'priorities',
  initialState: {
    items: [],
    selectedPriority: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Синхронное обновление приоритета (используется при получении событий)
    updatePriority: (state, action) => {
      const priority = action.payload;
      const index = state.items.findIndex(item => item.id === priority.id);
      
      if (index !== -1) {
        // Обновление существующего приоритета
        state.items[index] = {
          ...state.items[index],
          ...priority,
        };
      } else {
        // Добавление нового приоритета
        state.items.push(priority);
      }
      
      // Если открыта детальная страница приоритета, обновляем и её
      if (state.selectedPriority && state.selectedPriority.id === priority.id) {
        state.selectedPriority = {
          ...state.selectedPriority,
          ...priority,
        };
      }
    },
    
    // Удаление приоритета (используется при получении событий)
    deletePriority: (state, action) => {
      const id = action.payload;
      state.items = state.items.filter(item => item.id !== id);
      
      // Если открыта детальная страница удаляемого приоритета, очищаем её
      if (state.selectedPriority && state.selectedPriority.id === id) {
        state.selectedPriority = null;
      }
    },
    
    // Сброс выбранного приоритета
    resetSelectedPriority: (state) => {
      state.selectedPriority = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Обработка fetchPriorities
      .addCase(fetchPriorities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPriorities.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchPriorities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить приоритеты';
      })
      
      // Обработка fetchPriorityById
      .addCase(fetchPriorityById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPriorityById.fulfilled, (state, action) => {
        state.selectedPriority = action.payload;
        state.loading = false;
      })
      .addCase(fetchPriorityById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить приоритет';
      });
  },
});

// Экспорт экшенов
export const { updatePriority, deletePriority, resetSelectedPriority } = prioritiesSlice.actions;

// Селекторы
export const selectAllPriorities = (state) => state.priorities.items;
export const selectSelectedPriority = (state) => state.priorities.selectedPriority;
export const selectPrioritiesLoading = (state) => state.priorities.loading;
export const selectPrioritiesError = (state) => state.priorities.error;

// Экспорт редьюсера
export default prioritiesSlice.reducer; 